module.exports = "<div class=\"flex-container\">\n  <div class=\"container-loader\">\n    <div class=\"lds-simon\">\n      <div></div>\n      <div></div>\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n  </div>\n  <p class=\"logo-text\">SIMON</p>\n  <p class=\"logout-text\">{{ 'logout' | translate}}</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = ./src/app/logout/logout.component.html
// module chunks = main